import React from "react";
import { Router, Link } from "react-static";
import { hot } from "react-hot-loader";
import { Helmet } from "react-helmet";
import styled from "styled-components";
//
import { library, config } from "@fortawesome/fontawesome-svg-core";
import { fab } from "@fortawesome/free-brands-svg-icons";
import { faCaretDown, faCoffee } from "@fortawesome/free-solid-svg-icons";
library.add(fab);

import Routes from "react-static-routes";
import logoImg from "assets/brand/logo.png";
import logoTxt from "assets/brand/logo-text-center.png";
import Social from "components/social.js";
import Footer from "components/footer.js";
import Menu from "components/menu.js";
import Example from "components/mobile-menu.js";

import "./app.css";

const AbsoluteNav = styled.nav`
  position: absolute;
`;

const App = props => (
  <Router>
    <div id="outer-container">
      <Helmet>
        <title>Histo Tech</title>
        <link
          rel="apple-touch-icon"
          sizes="180x180"
          href="/favicon/apple-touch-icon.png"
        />
        <link
          rel="icon"
          type="image/png"
          sizes="32x32"
          href="/favicon/favicon-32x32.png"
        />
        <link
          rel="icon"
          type="image/png"
          sizes="16x16"
          href="/favicon/favicon-16x16.png"
        />
        <link rel="manifest" href="/favicon/site.webmanifest" />
        <meta name="msapplication-TileColor" content="#3473de" />
        <meta name="theme-color" content="#ffffff" />
      </Helmet>
      <Example />
      <div id="page-wrap">
        <header>
          <Link to="/">
            <img src={logoImg} width="100" />
          </Link>
          <Link to="/">
            <img src={logoTxt} width="100" />
          </Link>
          <Social />
        </header>
        <AbsoluteNav>
          <Menu />
        </AbsoluteNav>
        <div className="main">
          <div className="decoration">
            <div className="red" />
            <div className="blue" />
          </div>
          <div className="content">
            <Routes />
          </div>
        </div>
        <Footer />
      </div>
    </div>
  </Router>
);

export default hot(module)(App);



// WEBPACK FOOTER //
// /opt/build/repo/src/App.js